import { useEffect, useState } from 'react';

/**
 * Paging for a list filtered and sorted in the browser. Any change to `resetOn` (what matches, or
 * its order) or to the page size starts again at page 1; a page that empties under the reader
 * (rows removed on a refetch) falls back to the last page with rows.
 */
export function useClientPaging<T>(visible: readonly T[], resetOn: readonly unknown[], initialPageSize = 50) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(initialPageSize);
  const resetKey = JSON.stringify(resetOn);

  useEffect(() => setPage(1), [resetKey, pageSize]);
  const lastPage = Math.max(1, Math.ceil(visible.length / pageSize));
  useEffect(() => {
    if (page > lastPage) setPage(lastPage);
  }, [page, lastPage]);

  return { page, setPage, pageSize, setPageSize, pageRows: visible.slice((page - 1) * pageSize, page * pageSize) };
}
